enum ExtraCostPaymentType {
    REQUIRED_ON_BOOKING = 'Verplicht bij boeking',
    OPTIONAL_ON_BOOKING = 'Optioneel bij boeking',
    ON_ARRIVAL_COSTS = 'Verplicht ter plaatse',
    AFTER_STAY_COSTS = 'Verplicht na verblijf te betalen',
    OPTIONAL_ON_ARRIVAL_COSTS = 'Optioneel ter plaatse'
}

export default ExtraCostPaymentType;
